import type { ImageFragment } from '@haaretz/s-fragments/HTZ_image_Image';

export default function getImgTitle(
  caption: ImageFragment['caption'],
  credit: ImageFragment['credit']
) {
  const trimmedCaption = caption?.trim();
  const trimmedCredit = credit?.trim();

  if (!trimmedCaption && !trimmedCredit) return undefined;

  const captionStr =
    trimmedCaption && !trimmedCaption.endsWith('.') ? `${trimmedCaption}.` : trimmedCaption;
  const parts = [captionStr, trimmedCredit].filter(Boolean);
  const title = parts.join(' ');

  return title;
}
